import React from 'react';
import style from '../side_bar/style.module.scss';
import { paths } from 'config/path_helpers';
import moment from 'moment-timezone';
import LockIcon from '../../assets/lock_icon.svg';
import { useYourClassesContext } from '@magoosh/pages/live_classes/all_classes/context';

export const LiveClassesWidget: React.FC = () => {
  const { data, fetchData } = useYourClassesContext();

  React.useEffect(() => {
    fetchData('widget');
  }, []);

  return (
    <div className={style.section}>
      <h4>
        <strong>Live Classes</strong>
      </h4>
      {data.widget.upcoming.map((liveClass, idx) => {
        const dateTime = moment.utc(liveClass.dateTime).tz(moment.tz.guess());

        return (
          <div key={idx} className={style.sectionItem}>
            <p>
              {liveClass.name}
              <br />
              <small>
                {dateTime.isSame(moment(), 'day') ? 'Today' : dateTime.format('dddd, MMMM D')} at{' '}
                {dateTime.format('LT z')}
                <br />
                {liveClass.isLocked && (
                  <span className="d-flex align-items-center">
                    <br />
                    <img src={LockIcon} alt="lock" style={{ width: '15px' }} />
                    This class starts after your trial ends.
                  </span>
                )}
              </small>
            </p>
            {liveClass.isLocked ? (
              <a href={paths.plans()} target="_blank" style={{ color: style.brandSecondary }}>
                <strong>Upgrade</strong>
              </a>
            ) : (
              <a href={paths.liveClasses()} target="_blank" style={{ color: style.brandSecondary }}>
                <strong>Register</strong>
              </a>
            )}
          </div>
        );
      })}
      <a href={paths.liveClasses()}>See All Classes</a>
    </div>
  );
};

export default LiveClassesWidget;
